import { useErrors } from '@app/store';
import React from 'react';

const ErrorContent = () => {
  const errors = useErrors();
  return (
    <div className="flex flex-col items-center justify-center gap-6 w-full">
      <p className="text-lg font-semibold text-red-700 ml-2">Error Occured</p>
      {errors?.map((err) => <p className="text-sm break-all" key={err.code || err.message}>{err.message}</p>)}
      {(!errors || errors?.length === 0) ? <p className="text-sm">We couldn’t complete your request. Please refresh and try again.</p> : null}
    </div>
  );
};

export default ErrorContent;
